import './styles.scss';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { PostDateColumn } from './PostDateColumn';
import { PublicNoticeColumn } from './PublicNoticeColumn';
import { PublicNoticeAuction } from '../types';

interface PublicNoticeTableProps {
    auctions: PublicNoticeAuction[];
}

export function PublicNoticeTable({ auctions }: PublicNoticeTableProps) {
    return (
        <div>
            {auctions &&
                auctions.length > 0 &&
                auctions.map((auction, index) => (
                    <Row className="align-items-stretch no-gutters" key={index}>
                        <Col md={3} className="d-flex flex-column">
                            <PostDateColumn auction={auction}/>
                        </Col>
                        <Col md={9}>
                            <PublicNoticeColumn auction={auction}/>
                        </Col>
                    </Row>
                ))}
        </div>
    );
}
